<template>
              <table class='borderedtable'>
                <tr class="bigtitle2">
                  <th></th><th>予納</th><th>point</th>
                  <th>現金</th><th>card</th><th>gmo</th>
                  <th>meta</th><th>bank</th><th>TOTAL</th>
                </tr>
                <tr>
                  <td class="total">TOTAL</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats.prepay) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats.point) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats.cash) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats.card) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats.gmo) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats.meta) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats.bank) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats.total) }}</td>
                </tr>
                <tr v-if="userrole=='manager1'">
                  <td class="total strikeout">TOTAL</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats.prepay2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats.point2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats.cash2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats.card2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats.gmo2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats.meta2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats.bank2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats.total2) }}</td>
                </tr>
              </table>
</template>
<script>
import {FormatUtils} from  '@/classes/Utils/FormatUtils.js';
// 2025 09 12 t_field
import { userinfo } from '@/classes/UserInfo.js';
import { computed,  } from 'vue';

export default {

    props: [ 'stats', ],    // data received from the parent component (myaccounting)
    name: 'DayAccount',
    setup() {
      // 250907
      const userrole = computed(() => userinfo.get_userrole())

      return { FormatUtils, userrole}

    },
}
</script>


<style scoped>
.strikeout {
  /*text-decoration: line-through; */
  text-decoration: line-through;
  text-decoration-style: double;
  color: red; /* Optional: grey out completed tasks */
}

  .pink {
    background-color: rgb(209, 195, 189);
  }
  .green {
    background-color: rgb(157, 212, 210);
  }
.borderedtable {
    border: 1px solid black;
    border-collapse: collapse;
    width: 100%;
}
.border {
    border: 1px solid black;
    border-collapse: collapse;
}

     
      .black {
        color: black;
      }

</style>

